// Feature switches — set to true to re-enable a hidden module (code & data are kept).
export const FEATURES = {
  bank: false, // Relevés bancaires / rapprochement
};
